import * as Types from './free-to-play-types';

const isApiError = <T>(response: Types.ApiResponse<T>): response is Types.ApiError =>
	(response as Types.ApiError).error !== undefined;

class FreeToPlayApiClient {
	private baseUrl = '/rest/free-to-play';

	private async request<T>(url: string, method = 'GET'): Promise<T> {
		const response = <Types.ApiResponse<T>>(
			await fetch(this.baseUrl + url, { method }).then(_response => _response.json())
		);

		if (isApiError(response)) {
			throw new Error(response.error);
		}

		return response;
	}

	public async fetchCampaigns(preferredProduct: string) {
		return this.request<Types.CampaignsResponse>(`/campaigns?preferredProduct=${preferredProduct}`);
	}

	public async fetchCampaignById(id: string, type: string) {
		return this.request<Types.CampaignByIdResponse>(`/campaigns/${id}?type=${type}`);
	}

	public async fetchF2PConfig(preferredProduct: string | null | undefined) {
		if (preferredProduct) {
			return this.request<Types.F2PConfigResponse>(`/configurations?preferredProduct=${preferredProduct}`);
		}
		return this.request<Types.F2PConfigResponse>(`/configurations`);
	}
}

export default new FreeToPlayApiClient();
